import React, { useState } from 'react';
import { sendEmail } from '../../api';

function EmailTestDialog({ isOpen, onClose, user }) {
  const [email, setEmail] = useState('');
  const [emailType, setEmailType] = useState('test');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const emailTypes = [
    { value: 'test', label: 'Test E-Mail' },
    { value: 'password_reset', label: 'Passwort-Reset E-Mail' },
    { value: 'account_creation', label: 'Account-Erstellung E-Mail' },
    { value: 'optin_confirmation', label: 'Opt-In Bestätigung E-Mail' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setMessage('Bitte geben Sie eine E-Mail-Adresse ein.');
      setMessageType('error');
      return;
    }

    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setMessage('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await sendEmail({
        emailType: emailType,
        recipientEmail: email,
        recipientName: 'Test Empfänger',
        userId: user.id,
        organizationId: user.organization_id || 4
      });

      if (response.success) {
        setMessage('E-Mail wurde erfolgreich gesendet!');
        setMessageType('success');
        setEmail('');
      } else {
        setMessage('Fehler beim Senden der E-Mail: ' + response.error);
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Fehler beim Senden der E-Mail: ' + error.message);
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setEmailType('test');
    setMessage('');
    setMessageType('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-dialog">
        <div className="modal-header">
          <h3>E-Mail Test</h3>
          <button className="close-button" onClick={handleClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="email">E-Mail-Adresse:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="test@example.com"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="emailType">E-Mail-Typ:</label>
            <select
              id="emailType"
              value={emailType}
              onChange={(e) => setEmailType(e.target.value)}
            >
              {emailTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          {message && (
            <div className={`message ${messageType}`}>
              {message}
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="cancel-button" onClick={handleClose}>
              Abbrechen
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Sende...' : 'E-Mail senden'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EmailTestDialog; 